import { useState } from "react";
import { useAuthContext, fetchCsrfToken } from "../../../context/AuthContext";
import LoginBoard from "../../login/components/LoginBoard";

function formatSsoError(err) {
  const message = err?.message || "요청에 실패했습니다.";
  const code = err?.errorCode;
  const status = err?.status;

  if (status === 403 || /failed csrf check/i.test(message)) {
    return {
      message:
        "보안 확인에 실패했습니다. 페이지를 새로고침한 뒤 다시 시도해 주세요.",
      hint: null,
    };
  }

  const hint =
    code === "sso_session_missing"
      ? "위애나에서 에듀씨드 로그인을 처음부터 다시 시작해 주세요."
      : null;

  return { message, hint };
}

export default function WeaenaSsoLogin() {
  const { weaenaSsoCode } = useAuthContext();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [hint, setHint] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setHint(null);

    if (!fetchCsrfToken()) {
      setMessage("연결 준비 중입니다. 잠시 후 다시 시도해 주세요.");
      return;
    }

    if (!username.trim() || !password) {
      setMessage("아이디와 비밀번호를 입력해 주세요.");
      return;
    }

    setSubmitting(true);
    try {
      const redirectUrl = await weaenaSsoCode({
        username: username.trim(),
        password,
      });
      window.location.assign(redirectUrl);
    } catch (err) {
      const formatted = formatSsoError(err);
      setMessage(formatted.message);
      setHint(formatted.hint);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{ minHeight: "700px", width: "100%" }}
      className="d-flex justify-content-center align-items-center"
    >
      <div
        style={{
          minHeight: "700px",
          maxWidth: "1000px",
          width: "100%",
        }}
        className="d-flex justify-content-space-between flex-wrap login align-items-center"
      >
        <div className="col-sm-7 d-none d-sm-block">
          <LoginBoard />
        </div>
        <div className="col-sm-5">
          <div className="loginMain m-5 pt-5">
            <main className="form-signin">
              <form className="needs-validation" noValidate onSubmit={handleSubmit}>
                <h1 className="h3 mb-4 fw-normal">위애나 SSO 로그인</h1>
                <p className="text-muted small mb-4">
                  위애나에서 연동을 시작한 경우에만 이용할 수 있습니다.
                </p>

                {message && (
                  <div className="alert alert-danger" role="alert">
                    {message}
                    {hint && (
                      <div className="small mt-2 mb-0">{hint}</div>
                    )}
                  </div>
                )}

                <div className="form-floating mb-2">
                  <input
                    type="text"
                    className="form-control"
                    id="weaena-sso-username"
                    name="username"
                    placeholder="아이디"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoCapitalize="off"
                    autoCorrect="off"
                    autoComplete="username"
                  />
                  <label htmlFor="weaena-sso-username">아이디</label>
                </div>

                <div className="form-floating mb-3">
                  <input
                    type="password"
                    className="form-control"
                    id="weaena-sso-password"
                    name="password"
                    placeholder="비밀번호"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <label htmlFor="weaena-sso-password">비밀번호</label>
                </div>

                <button
                  type="submit"
                  className="w-100 btn btn-lg btn-primary"
                  disabled={submitting}
                >
                  {submitting ? "처리 중…" : "로그인 후 위애나로 이동"}
                </button>
              </form>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
